import { selectOnboardingRedirect, type OnboardingPageId } from './redirects';
import { useOnboardingSignals } from './use-onboarding-signals';

export type OnboardingRedirectResult = {
  /** Where the page should send the user, or `null` to stay. */
  redirect: string | null;
  /** Callers must render a loader: `redirect` is withheld until this settles. */
  isLoading: boolean;
};

/**
 * Stay-or-go decision for an `/onboarding/*` page. Ignores
 * `hasUntrustedSignal` on purpose: a failed answers read fails open to "not
 * answered", which safely leaves the user on the page they already opened.
 */
export function useOnboardingRedirect(page: OnboardingPageId): OnboardingRedirectResult {
  const { isLoading, ...state } = useOnboardingSignals();

  if (isLoading) {
    return { redirect: null, isLoading: true };
  }

  return {
    redirect: selectOnboardingRedirect({ page, ...state }),
    isLoading: false,
  };
}
